﻿//import "./util/popupPlus_Aux";



//----------------------------------------------------------------------------------



//----------------------------------------------------------------------------------
// page wrappers
import { cmux_client_cart_wrapper } from "./pages/cmux_client_cart";
export { cmux_client_cart_wrapper };


import { cmux_general_wrapper } from "./apps/cmux_general";
export { cmux_general_wrapper };

import { sys_general_wrapper } from "./sys/sys_general";
export { sys_general_wrapper };




import { CMU_Bus101_wrapper } from "./pages/cmux_bus101";
export { CMU_Bus101_wrapper };

import { CMU_Bus103_wrapper } from "./pages/cmux_bus103";
export { CMU_Bus103_wrapper };

import { CMU_Bus104_wrapper } from "./pages/cmux_bus104";
export { CMU_Bus104_wrapper };

import { CMU_Bus105_wrapper } from "./pages/cmux_bus105";
export { CMU_Bus105_wrapper };

import { CMU_Bus106_wrapper } from "./pages/cmux_bus106";
export { CMU_Bus106_wrapper };

import { CMU_Bus107_wrapper } from "./pages/cmux_bus107";
export { CMU_Bus107_wrapper };

import { SYS_Bus100_wrapper } from "./pages/sys_bus100";
export { SYS_Bus100_wrapper };

import { SYS_Bus101_wrapper } from "./pages/sys_bus101";
export { SYS_Bus101_wrapper };



import { spt_test_canvas_container } from "./pages/spt_test_canvas";
export { spt_test_canvas_container };
//----------------------------------------------------------------------------------








import { oBase, Ilk, oBool, oColor, oDaton, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "./util/ovars";
export { oBase, Ilk, oBool, oColor, oDaton, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd };

import { UTL } from "./util/classes";
export { UTL };


import { TRANS } from "./util/classes";
export { TRANS };

import { STR } from "./util/classes";
export { STR };


import { Elcon } from "./util/classes";
export { Elcon };


import { DLG } from "./util/classes";
export { DLG };

import { GSP } from "./util/classes";
export { GSP };

import { Catlist } from "./util/classes";
export { Catlist };

import { Whisper } from "./util/classes";
export { Whisper };

import { VECTOR, VECTOR_Capsule, VECTOR_Info } from "./util/classes";
export { VECTOR, VECTOR_Capsule, VECTOR_Info };

import { CdFnCntPayload } from "./util/classes";
export { CdFnCntPayload };

import { COMM_LOGIC_TYPE } from "./util/classes";
export { COMM_LOGIC_TYPE };


import { CMP } from "./util/cmp";
export { CMP };

import { SMART_CMP } from "./util/smart_cmp";
export { SMART_CMP };

import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "./util/classes";
export { TABLE, TableObject, TBLSCROLLER, TABLE_Location };


import { TABLE_SORT_ROWS_AUX_FUNCTIONS } from "./util/classes";
export { TABLE_SORT_ROWS_AUX_FUNCTIONS };

import { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS } from "./util/classes";
export { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS };

import { TABLE_CELL_MARKER_UTILITIES } from "./util/classes";
export { TABLE_CELL_MARKER_UTILITIES };



import { DOM_AUX_FUNCTIONS } from "./util/classes";
export { DOM_AUX_FUNCTIONS };


import { SOUND_UTILS_USING_AUDIO_CONTEXT, SOUND_UTIL_PLAY_AUDIO_FILE } from "./util/classes";
export { SOUND_UTILS_USING_AUDIO_CONTEXT, SOUND_UTIL_PLAY_AUDIO_FILE };

import { DOM_VISUAL_EFFECTS } from "./util/classes";
export { DOM_VISUAL_EFFECTS };


import { ARRAY_UTILITIES } from "./util/classes";
export { ARRAY_UTILITIES };


import { RANDOM_UTILITIES } from "./util/random";
export { RANDOM_UTILITIES };


import { PROGRAMMATICALLY_CREATED_ELEMENTS } from "./util/classes";
export { PROGRAMMATICALLY_CREATED_ELEMENTS };


import { DOMRect_UTILITIES } from "./util/classes";
export { DOMRect_UTILITIES };


import { SVG_UTILITIES } from "./util/svg";
export { SVG_UTILITIES };


import { DIALOG500 } from "./util/dialog500";
export { DIALOG500 };



import { SPOT_UTILITIES } from "./util/spot_utilities";
export { SPOT_UTILITIES };






import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "./util/popupPlus_Aux"; // <--- ייבוא הפונקציה הספציפית
export { PopupPlusStyleRecord, PopupPlusAuxFunctions };

import { AlertPlus } from "./util/popupPlus_Alert"; // <--- ייבוא הפונקציה הספציפית
export { AlertPlus };

import { ConfirmPlus } from "./util/popupPlus_Confirm"; // <--- ייבוא הפונקציה הספציפית
export { ConfirmPlus };

import { PromptPlus } from "./util/popupPlus_Prompt"; // <--- ייבוא הפונקציה הספציפית
export { PromptPlus };

import { AnnouncePlus } from "./util/popupPlus_Announce"; // <--- ייבוא הפונקציה הספציפית
export { AnnouncePlus };

import { NotifyPlus, NotifyPlusStyleRecord, NotifyPlusAuxFunctions  } from "./util/popupPlus_Notify"; // <--- ייבוא הפונקציה הספציפית
export { NotifyPlus, NotifyPlusStyleRecord, NotifyPlusAuxFunctions };

import { FacadePlus } from "./util/popupPlus_Facade"; // <--- ייבוא הפונקציה הספציפית
export { FacadePlus };

import { NRECT } from "./util/classes";
export { NRECT };


import { CANVAS } from "./util/CANVAS"; // <--- ייבוא הפונקציה הספציפית
export { CANVAS };


import { Alloy } from "./util/classes";
export { Alloy };


console.log("Vite is working (this is my message)");


(window as any).Util = {
    // i shall put here the utilities
    UTL,
    TRANS,
    STR,

    PopupPlusStyleRecord,
    PopupPlusAuxFunctions,

    AlertPlus,
    ConfirmPlus,
    PromptPlus,
    AnnouncePlus,
    NotifyPlus, 
    NotifyPlusStyleRecord,
    NotifyPlusAuxFunctions,
    FacadePlus,
    CMP,
    SMART_CMP,
    TABLE_SORT_ROWS_AUX_FUNCTIONS,
    TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS,
    TABLE_CELL_MARKER_UTILITIES,
    DOM_AUX_FUNCTIONS,
    SOUND_UTILS_USING_AUDIO_CONTEXT, SOUND_UTIL_PLAY_AUDIO_FILE,
    DOM_VISUAL_EFFECTS,
    ARRAY_UTILITIES,
    RANDOM_UTILITIES,
    PROGRAMMATICALLY_CREATED_ELEMENTS,
    SVG_UTILITIES,
    SPOT_UTILITIES,
    DOMRect_UTILITIES,
    NRECT,
    CANVAS,
    Alloy
};




(window as any).App = {
    // i shall put here what belongs to app itslef
    //-----------------------------------------
    //-----------------------------------------
    // wrappers
    cmux_general_wrapper,
    sys_general_wrapper,
    cmux_client_cart_wrapper,
    //-----------------------------------------
    CMU_Bus101_wrapper,
    CMU_Bus103_wrapper,
    CMU_Bus104_wrapper,
    CMU_Bus105_wrapper,
    CMU_Bus106_wrapper,
    CMU_Bus107_wrapper,

    SYS_Bus100_wrapper,
    SYS_Bus101_wrapper,
    spt_test_canvas_container,
    //-----------------------------------------
};


//(window as any).oBase = oBase;
//(window as any).UTL = UTL;
//(window as any).DLG = DLG;
